const imageExists = (url, callback) => {
  const img = new Image();

  img.onload = () => callback(true, url);

  img.onerror = () => callback(false, url);

  img.src = url;
};

export default imageExists;